import React, { Suspense, useState, useEffect } from "react";
import systemListingService from "./SystemListingServices";
import { FormatReleaseDrawer } from "../../AssetLinking/MenuDrawer";
import Pagination from "components/Common/newPagination";

export default function FormatReleasePage(param: any) {

  var payload = { pageNumber: 1, pageSize: 10 }
  let [formatReleaseCount, setformatReleaseCount] = useState<number>(0);
  const [editingOn, setEditingOn] = useState<boolean>(false);
  const [formatReleaseListing, SetFormatReleaseListing] = useState<any>([]);

  useEffect(() => {
    if (param.activeTab === "Format Release") {
      formatReleaseSelect()
    }
  }, [param])


  const formatReleaseSelect = () => {
    formatReleaseCount = 0
    setformatReleaseCount(formatReleaseCount)

    systemListingService.FormatReleaseListing(payload).then((res:any) => {
      SetFormatReleaseListing(res);
      formatReleaseCount = res && res[0].totalRows ? res[0].totalRows : 0
      console.log(res[0].totalRows)
      console.log(formatReleaseCount)
      setformatReleaseCount(formatReleaseCount)
    })
  }

  const onPageChange = (e: any) => {
    console.log(e)
    payload.pageNumber = e.pageNumber;
    payload.pageSize = e.pageSize;
    formatReleaseSelect()
  }

  return (
    <div>

      <div className="content-card ws-12">
        {/* Card header */}
        <div className="card-header-row ws-12">
          <div className="card-title">Format Release</div>
          <div className="card-header-actions">
            <span className="pt mt">
              {formatReleaseCount} record(s) found
            </span>

            <button className="icon-btn info" id="editModeBtn" type="button" onClick={() => setEditingOn((prev) => !prev)}   >
              {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="table-wrapper ws-12">

          {formatReleaseCount > 0 && <table className={editingOn ? "editing-on newTable" : "newTable"}>
            <thead>
              <tr>
                <th className="col-release-number">Release Number</th>
                <th className="col-release-desc">
                  Release Description
                </th>
                <th style={{ width: 120, textAlign: "center" }}>
                  Operations
                </th>
              </tr>
            </thead>
            <tbody>
              {formatReleaseListing.map((row: any) => (
                <tr key={row.number}>
                  <td className="col-release-number">{row.relNum}</td>
                  <td className="col-release-desc">  {row.releaseDesc}  </td>
                  <td style={{ width: "10%" }}>

                    <div style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }}  >

                      <button className="icon-btn edit" disabled={!editingOn} title="Edit" type="button">
                        <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M12 20h9" />
                          <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
                        </svg>
                      </button>
                      <button className="icon-btn delete" title="Delete" type="button" disabled={!editingOn} >
                        <i className="icon-trash"> </i>
                      </button>


                    </div>
                  </td>
                </tr>
              ))}
              {formatReleaseListing.length === 0 && (
                <tr>
                  <td colSpan={3} style={{ textAlign: "center", padding: "12px" }}  >
                    No records match your search.
                  </td>
                </tr>
              )}
            </tbody>
          </table>}

          {formatReleaseCount > 10 && <div className="ws-10">
            <Pagination totalRow={formatReleaseCount} onPageChange={onPageChange} />
          </div>}
        </div>

        {/* Add Release button – same place as other pages */}
        <div className="add-row-wrapper" style={{ marginTop: 12, display: "flex", justifyContent: "flex-start", }} >
          <button className="btn-add-row" type="button" >
            + Add Release
          </button>
        </div>
      </div>

    </div>
  );
}; 
